import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import FullScreen from '@blade/common/components/full-screen.vue';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import { Queue } from '@blade-sxp/monitor/components/monitor-management/task';
let default_1 = class extends Vue {
    srcMsg = require('@blade/common/assets/svgs/enlarge.svg');
    srcMsg2 = require('@blade/common/assets/svgs/narrow.svg');
    onFullScreenFlag = false;
    recordData = '';
    selectValue = '';
    handleCreate() {
        this.$router.push('/application/queue/taskManagement/createQueueControl');
    }
    handleClick(tab, event) {
        console.log(tab, event);
    }
    handleRefresh() {
        this.getCurrentTable().getTaskList();
    }
    handleReset() {
        this.selectValue = '';
        this.$nextTick(() => {
            this.getCurrentTable()?.getTaskList();
        });
    }
    handleSearch() {
        this.getCurrentTable()?.getTaskList();
    }
    getCurrentTable() {
        return this.$refs.queue;
    }
    onFullScreen() {
        this.onFullScreenFlag = !this.onFullScreenFlag;
        this.$refs.fullscreen.toggle();
    }
};
default_1 = __decorate([
    Component({
        name: 'queueTask',
        components: {
            Queue,
            FullScreen,
            AuthItem,
        },
    })
], default_1);
export default default_1;
